import { StatusEnum } from '@/types';

import {
  ATTACHMENTS_TOOLBAR_ACTION,
  ATTACHMENTS_TOOLBAR_KEY_EVENT,
  ATTACHMENTS_TOOLBAR_KEY_UPDATE_EVENT,
} from './AttachmentsToolbar.keys';

import type {
  AddAttachmentActionPayload,
  RemoveAttachmentActionPayload,
  UpdateAttachmentActionPayload,
  UpdateAttachmentsActionPayload,
  AttachmentUploadState,
} from './AttachmentsToolbar.types';

export const addAttachmentAction = (payload: AddAttachmentActionPayload) => ({
  type: ATTACHMENTS_TOOLBAR_ACTION.ADD,
  payload: {
    attachment_id: crypto.randomUUID(),
    status: StatusEnum.PENDING,
    ...payload,
  },
});

export const addAttachmentsAction = (
  payload: AddAttachmentActionPayload[],
) => ({
  type: ATTACHMENTS_TOOLBAR_ACTION.ADD_MANY,
  payload: payload.map((item) => ({
    attachment_id: crypto.randomUUID(),
    status: StatusEnum.PENDING,
    ...item,
  })),
});

export const updateAttachmentAction = (
  payload: UpdateAttachmentActionPayload,
) => ({
  type: ATTACHMENTS_TOOLBAR_ACTION.UPDATE,
  payload,
});

export const updateAttachmentStatusAction = (
  payload: Pick<AttachmentUploadState, 'attachment_id' | 'status'>,
) => ({
  type: ATTACHMENTS_TOOLBAR_ACTION.UPDATE_STATUS,
  payload,
});

export const updateAttachmentsStatusAction = (
  payload: Pick<UpdateAttachmentsActionPayload, 'attachment_ids'> &
    AttachmentUploadState['status'],
) => ({
  type: ATTACHMENTS_TOOLBAR_ACTION.UPDATE_STATUS_MANY,
  payload,
});

export const updateAttachmentProgressAction = (
  payload: Pick<AttachmentUploadState, 'attachment_id' | 'progress'>,
) => ({
  type: ATTACHMENTS_TOOLBAR_ACTION.UPDATE_PROGRESS,
  payload,
});

export const updateAttachmentsAction = (
  payload: UpdateAttachmentsActionPayload,
) => ({
  type: ATTACHMENTS_TOOLBAR_ACTION.UPDATE_MANY,
  payload,
});

export const removeAttachmentAction = (
  payload: RemoveAttachmentActionPayload,
) => ({
  type: ATTACHMENTS_TOOLBAR_ACTION.REMOVE,
  payload,
});

export const removeAllAttachmentsAction = () => ({
  type: ATTACHMENTS_TOOLBAR_ACTION.REMOVE_ALL,
});

export const triggerAttachmentToolbarEvent = (action) => {
  document.dispatchEvent(
    new CustomEvent(ATTACHMENTS_TOOLBAR_KEY_EVENT, {
      detail: action,
    }),
  );
};

export const triggerAttachmentToolbarUpdateEvent = (action) => {
  document.dispatchEvent(
    new CustomEvent(ATTACHMENTS_TOOLBAR_KEY_UPDATE_EVENT, {
      detail: action,
    }),
  );
};
